/** Default UI locale when user, workspace, and device provide nothing usable. */
export const APP_FALLBACK_LANGUAGE = 'en-US';

/** Default IANA zone when user, workspace, and device provide nothing usable. */
export const APP_FALLBACK_TIMEZONE = 'UTC';

/**
 * Only these BCP-47 tags may be chosen for user (`profiles.language_preference`)
 * and workspace (`account_workspace_identity.default_language`).
 * Order is picker-friendly (not strict alpha).
 *
 * UI copy is provided by the locale overlays registered for each supported
 * tag; **Intl** formats dates/numbers in the active tag as well.
 */
export const APP_SUPPORTED_LANGUAGE_TAGS = [
  'ar',
  'en-US',
  'en-GB',
  'en-AU',
  'de-DE',
  'fr-FR',
  'es-ES',
] as const;

export type AppSupportedLanguageTag = (typeof APP_SUPPORTED_LANGUAGE_TAGS)[number];
